<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="addurl">
        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("title") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="text"
            v-model="inputs.title"
            :required="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_email" class="col-sm-3 mb-0">
            {{ $t("description") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="textarea"
            v-model="inputs.description"
            :required="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_email" class="col-sm-3 mb-0">
            {{ $t("shortdescription") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="textarea"
            v-model="inputs.shortdescription"
            :required="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_email" class="col-sm-3 mb-0">
            {{ $t("categorytag") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="textarea"
            v-model="inputs.categorytag"
            :required="true"
          />
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("category") }}
          </label>
          <app-input
            type="search-select"
            class="col-sm-9"
            :placeholder="$t('category')"
            :list="this.categories"
            v-model="inputs.category"
          />
        </div>

        <div class="form-group row mb-0">
            <label class="col-sm-2 mb-sm-0">
              {{ $t("upload") }}
            </label>
            <div class="col-sm-8">
              <app-input
                type="custom-file-upload"
                :label="$t('upload_your_file')"
                v-model="inputs.image"
                :required="true"
              />
              <small class="text-muted font-italic">
                {{ $t("recommended_custom_file_validation") }}
              </small>
            </div>
          </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
import { CATEGORIES, CATEGORY_STORE, CATEGORY_UPDATE } from "../../../../Config/ApiUrl";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      addurl: CATEGORY_STORE,
      preloader: false,
      inputs: {},
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
      dropzone_files: [],
      categories: [],
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.addurl = CATEGORY_UPDATE;
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      let formData = new FormData();

      // if (this.dropzone_files.length) {
      //   this.dropzone_files.forEach((dropzone_file) =>
      //     formData.append(`dropzone_file[]`, dropzone_file)
      //   );
      // }
 
      this.inputs.path =  this.inputs.image != null ? this.inputs.image['name'] : '';
      Object.keys(this.inputs).forEach((key) => {
        formData.append(key, this.inputs[key]);
      });
      if (this.modalTitle == "Edit") {

        this.preloader = true;
        axiosPost(this.addurl, formData)
          .then((res) => {
            
            this.$toastr.s(res.data.type);
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#demo-add-edit-Modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      } else {

        this.save(formData);
      }
      
      // this.$toastr.s(res.data.message);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.inputs.category = response.data.category;
      this.preloader = false;
    },

    getCategories() {
      axiosGet(CATEGORIES)
        .then((res) => {
          
          this.categories = res.data;
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    this.getCategories();
  },
};
</script>
